import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=1205b3a3&"
import script from "./PricingTable.vue?vue&type=script&lang=ts&"
export * from "./PricingTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports